import { SessionStorageKey } from "../../types/session-storage/session-storage-key";

export const setSessionStorageAccessToken = (accessToken: string) => {
  sessionStorage.setItem(SessionStorageKey.AccessToken, accessToken);
};

export const clearSessionStorageAccessToken = () => {
  sessionStorage.removeItem(SessionStorageKey.AccessToken);
};
